<template>
    <v-radio-group
        v-show="clientTypeValues.length > 1"
        v-model="clientType"
        class="client-type-chooser"
        :disabled="disabled"
        :inline="!isMobile"
    >
        <v-radio
            v-for="type in clientTypeValues"
            :key="type"
            :label="`${$t(`statement_of_account.client_types.${type}`)}`"
            :value="type"
        />
    </v-radio-group>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class ClientTypeChooser extends Vue {
        @VModel() clientType
        @Prop() disabled

        async mounted() {
            this.clientType = this.clientTypeValues[0]
        }

        get clientTypeValues() {
            const cc = this.$conf.public.account.showCorporateClients ? ['cc'] : []
            const ta = this.$conf.public.account.showAgencies ? ['ta'] : []
            if (this.isTO1 || this.isTO2) {
                return ['pc', ...cc, ...ta]
            } else if (this.isAgency) {
                return ['pc', ...cc]
            } else if (!authStore.person) {
                return ['pc']
            }
            return []
        }

        get isTO1() {
            return authStore.isTO1
        }

        get isB2C() {
            return authStore.isB2C
        }

        get isCorporate() {
            return authStore.isCorporate
        }

        get isTO2() {
            return authStore.isTO2
        }

        get isAgency() {
            return authStore.isAgency
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default ClientTypeChooser
</script>
